export const isEmailSupported = (email: string | null) => {
  return (
    email &&
    ["quickcommerce.org", "tryzapp.com"].includes(email.split("@")?.[1])
  );
};
